(function () {
	var initialCartFetched = false;

	class WDNCartQuantity extends WDNQuantity {
		constructor() {
			super();
		}

		onQuantityChange() {
			this.dispatchEvent(new Event("change"));
		}
	}

	customElements.define("wdn-cart-quantity", WDNCartQuantity);

	class WDNCart extends HTMLElement {
		constructor() {
			super();

			this.form;
			this.lineQtyList;
			this.drawerTriggers = document.querySelectorAll("wdn-drawer-open[data-id='cart']");
			this.drawer = document.querySelector('wdn-drawer[data-id="cart"]');
			this.sectionsToRender = ["cart-drawer", "cart-recommended-products", "header-cart-controller", "template-cart"];

			this.bindDrawerTriggers();
		}

		handleTriggerInteraction(e) {
			if (initialCartFetched) return;
			var callback = function () {
				this.mount();
			}.bind(this);
			this.reloadCart(true, e.type === "mouseover", callback);
			this.unbindDrawerTriggers();
			initialCartFetched = true;
		}

		whenOnTemplateCart() {
			if (document.body.classList.contains('template-cart')) {
				this.mount();
				this.unbindDrawerTriggers();
				initialCartFetched = true;
			}
		}

		registerNodes() {
			this.lineQtyList = document.querySelectorAll("wdn-cart-quantity");
			this.lineRemoveList = document.querySelectorAll("wdn-cart-remove");
		}

		registerQtyChange() {
			this.lineQtyList.forEach(function (elem) {
				elem.addEventListener("change", this.handleQtyChange.bind(this, elem));
			}, this);
		}

		handleLineRemove(elem) {
			this.handleQtyChange(elem);
		}

		registerRemove() {
			this.lineRemoveList.forEach(function (elem) {
				elem.addEventListener("click", this.handleLineRemove.bind(this, elem));
			}, this);
		}

		reloadRecommendationsFromAPI() {
			var recommendationsNode = document.querySelector(".cart-drawer__recommendations");

			if (!document.querySelector(".cart_item")) {
				if (!recommendationsNode.classList.contains("hide--cart-recommendations")) recommendationsNode.classList.add("hide--cart-recommendations");
				return;
			}
			if (recommendationsNode.classList.contains("hide--cart-recommendations")) recommendationsNode.classList.remove("hide--cart-recommendations");
			var ignoreList = document.querySelector("[data-already-rendered-recommendations]").content.split(",");
			var recommendationsURL = document.querySelector("[data-recommendations-url]").content;

			var onRecommendationLoad = function (res) {
				var targ = document.querySelector(".cart-recommended-products-grid");
				var productElemItems = new DOMParser().parseFromString(res, "text/html").querySelector(".shopify-section");

				var itemFragtment = new DocumentFragment();

				var itemList = productElemItems.querySelectorAll("[data-product-id]");

				Array.from(itemList).forEach(function (elem) {
					if (ignoreList.indexOf(elem.getAttribute("data-product-id")) === -1) {
						itemFragtment.append(elem);
					}
				});

				targ.append(itemFragtment);
			};

			var loadRecommendations = function () {
				var sectionName = "cart_recommendations_api";

				var req = new XMLHttpRequest();

				req.onreadystatechange = function () {
					if (req.readyState == 4) {
						if (req.status == 200) {
							onRecommendationLoad(req.responseText);
						}
					}
				};

				req.open("GET", recommendationsURL, true);
				req.send(null);
			};

			loadRecommendations();
		}

		reloadCart(noOpenCart, blockCartOpen, callback) {
			var reqData = {};
			reqData.sections = this.sectionsToRender;

			var reqDataJSON = JSON.stringify(reqData);
			var updateDOM = this.updateDOM.bind(this);
			var CartDrawer = this.drawer;

			var req = new XMLHttpRequest();
			req.open("GET", "/cart?sections=" + this.sectionsToRender.join(","), true);
			req.setRequestHeader("Content-Type", "application/json");

			req.onreadystatechange = function () {
				if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
					updateDOM(this.responseText);
					document.dispatchEvent(new CustomEvent("cartlayout:updated", {
						detail: {
							cartResponseText: this.responseText,
						}
					}));

					if (typeof callback === "function") {
						callback();
					}

					if (blockCartOpen) {
						return;
					}

					if (!noOpenCart || window.location.pathname.indexOf("/cart") === -1) {
						CartDrawer.open();
					}
				}
			};

			req.send();
		}


		surfaceError(str, lineElem) {
			if (!str?.trim()) return;
			const errorBanner = lineElem?.closest(".cart_item")?.querySelector("[data-cart-item-update-error]");
			if (!errorBanner) return;
			errorBanner.innerText = str;
		}

		clearError(lineElem) {
			const errorBanner = lineElem?.closest(".cart_item")?.querySelector("[data-cart-item-update-error]");
			if (!errorBanner) return;
			errorBanner.innerText = "";
		}

		handleQtyChange(elem) {
			var reqData = {};
			reqData.line = elem.getAttribute("data-line");
			reqData.quantity = elem.value || 0;
			reqData.sections = this.sectionsToRender;
			reqData.sections_url = "/cart";

			var reqDataJSON = JSON.stringify(reqData);
			var updateDOM = this.updateDOM.bind(this);

			var req = new XMLHttpRequest();
			req.open("POST", "/cart/change.json", true);
			req.setRequestHeader("Content-Type", "application/json");

			this.clearError(elem);
			const that = this

			req.onreadystatechange = function () {
				if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
					updateDOM(this.responseText);
					document.body.dispatchEvent(new CustomEvent("cartcount:update", { detail: "" }));
					document.dispatchEvent(new CustomEvent("cartlayout:updated", {
						detail: {
							cartResponseText: this.responseText,
						}
					}));
				}

				if (this.readyState === XMLHttpRequest.DONE && this.status >= 400) {
					try {
						const { errors } = JSON.parse(this.responseText);
						that.surfaceError(errors || "Error", elem)
					} catch (error) {
						console.error(error)
						alert("Error")
					}
				}
			};

			req.send(reqDataJSON);
		}

		_renderSection(text, name) {
			var resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-" + name).innerHTML;
			var resultTarget = document.querySelector("#shopify-section-" + name);

			if (resultTarget) {
				resultTarget.innerHTML = resultsMarkup;
			}
		}

		updateDOM(req) {
			var reqJSON = JSON.parse(req);
			var sections = reqJSON.sections || reqJSON;

			this.sectionsToRender.forEach(function (name) {
				var content = sections[name];
				this._renderSection(content, name);
			}, this);

			WDN.Countdown.reInit();
			this.reloadRecommendationsFromAPI();
			this.mount();
		}

		unbindDrawerTriggers() {
			this.drawerTriggers.forEach(function (trigger) {
				trigger.removeEventListener("click", this.handleTriggerInteractionBound);
				trigger.removeEventListener("mouseover", this.handleTriggerInteractionBound);
			}, this);
		}

		bindDrawerTriggers() {
			if (initialCartFetched) return;
			this.handleTriggerInteractionBound = this.handleTriggerInteraction.bind(this);
			this.drawerTriggers.forEach(function (trigger) {
				trigger.addEventListener("click", this.handleTriggerInteractionBound);
				trigger.addEventListener("mouseover", this.handleTriggerInteractionBound);
			}, this);
		}

		mount() {
			this.registerNodes();
			this.registerRemove();
			this.registerQtyChange();
		}

		connectedCallback() {
			this.whenOnTemplateCart();
		}
	}

	customElements.define("wdn-cart", WDNCart);

	class WDNCartUpsellTrigger extends HTMLElement {
		constructor() {
			super();

			this.action = this.getAttribute("action");
			this.targetContainer = document.querySelector(".cart-drawer__recommendations");

			this.onClickAction = this.action === "open" ? this.openOnClick : this.closeOnClick;
			this.mount();
		}

		handleClickAction() {
			this.onClickAction();
		}

		openOnClick() {
			this.targetContainer.setAttribute("data-recommendations-mobile-open", "");
		}

		closeOnClick() {
			this.targetContainer.removeAttribute("data-recommendations-mobile-open");
		}

		attachListener() {
			this.addEventListener("click", this.handleClickAction.bind(this));
		}

		mount() {
			this.attachListener();
		}
	}

	customElements.define("wdn-cart-upsell-trigger", WDNCartUpsellTrigger);

	document.body.addEventListener("overlay:opened", function (r) {
		if (r.detail && r.detail.getAttribute("data-id") && r.detail.getAttribute("data-id") === "cart") {
			document.body.setAttribute("data-cart-drawer-active", "");
		}
	});

	document.body.addEventListener("overlay:closed", function (r) {
		if (r.detail && r.detail.getAttribute("data-id") && r.detail.getAttribute("data-id") === "cart") {
			document.body.removeAttribute("data-cart-drawer-active");
		}
	});
})();

(function () {
	var init, bind;
	// event callbacks
	var linkOnMouseEnter, navOnMouseLeave, linkOnMouseLeave, bodyOnMouseMove;
	// handlers
	var handleLinkMouseEnter, handleNavMouseLeave;
	// functions
	var navigationIsAnimated, appendBodyClass, bodyOnMouseMoveBound;
	// getters
	var getLinkDropdown, getLinkId, getDropdownById;
	// setters
	var setActiveLink, setInactive;

	var config = {
		// selectors
		link_selector: ".mainlink",
		nav_selector: ".nav__dropdown",
		nav_main_selector: ".nav__main",
		sticky_nav_selector: ".nds__main",
		// classes
		body_class: "nav__main--animated",
		active_link_class: "link--hovered",
		// delays
		link_mouseenter_delay: 500,
		nav_mouseleave_delay: 250
	};

	var nodes = {
		links: document.querySelectorAll(config.link_selector),
		nav_dropdowns: document.querySelectorAll(config.nav_selector),
		nav_main: document.querySelector(config.nav_main_selector),
		sticky_nav: document.querySelector(config.sticky_nav_selector),
		body: document.body
	};

	// will be populated dynamically
	var data = {
		active_link: false,
		links: {},
		link_mouseenter_timeout: false
	};

	var main_links = {};

	setActiveLink = function (link) {
		if (link == data.active_link) return;
		if (data.active_link) {
			// clearing current active link
			data.active_link.classList.remove(config.active_link_class);
		}

		if (main_links.active) {
			main_links.active.classList.remove("sticky--hovered");
			main_links.active.classList.remove(config.active_link_class);
		}

		// if sticky navigation is hovered
		applyChangeOnMainLink(link);

		if (link) {
			link.focus();
			link.classList.add(config.active_link_class);
		}

		data.active_link = link || false;
	};

	var applyChangeOnMainLink = function (link) {
		if (!link) {
			main_links.active = false;
			return;
		}
		if (!nodes.sticky_nav.contains(link)) return;
		var linkId = getLinkId(link);
		main_links.active = main_links[linkId];
		main_links.active.classList.add(config.active_link_class);
		main_links.active.classList.add("sticky--hovered");
	};

	navigationIsAnimated = function () {
		return nodes.body.classList.contains(config.body_class);
	};

	appendBodyClass = function (state) {
		var bodyClass = nodes.body.classList;
		if (state) {
			bodyClass.add(config.body_class);
		} else {
			bodyClass.remove(config.body_class);
		}
	};

	getLinkId = function (link) {
		return link.getAttribute("data-main-link");
	};

	getDropdownById = function (id) {
		var selector = "[data-nav-link='" + id + "']";

		// storing information on the object, to prevent queryselector every time
		if (!data.links.hasOwnProperty(id)) {
			data.links[id] = document.querySelector(selector);
		}

		return data.links[id];
	};

	// returns dropdown associated with the link
	getLinkDropdown = function (link) {
		if (!link) return;
		return getDropdownById(getLinkId(link));
	};

	handleLinkMouseEnter = function (link) {
		var link = link || this;
		setActiveLink(link);

		if (getLinkDropdown(link)) {
			appendBodyClass(true);
		}
		nodes.body.addEventListener("mousemove", bodyOnMouseMoveBound);
	};

	bodyOnMouseMove = function (e) {
		if (nodes.nav_main.contains(e.target) || nodes.sticky_nav.contains(e.target)) return;
		// cursor left nav_main, unbind event and close dropdown
		nodes.body.removeEventListener("mousemove", bodyOnMouseMoveBound);
		setInactive();
	};

	handleNavMouseLeave = function () {
		setInactive();
	};

	setInactive = function () {
		setActiveLink(false);
		appendBodyClass(false);
	};

	linkOnMouseEnter = function (e) {
		if (data.active_link) {
			handleLinkMouseEnter(this);
		} else {
			data.link_mouseenter_timeout = setTimeout(handleLinkMouseEnter.bind(this), config.link_mouseenter_delay);
		}
	};

	navOnMouseLeave = function () {
		setTimeout(handleNavMouseLeave.bind(this), config.nav_mouseleave_delay);
	};

	linkOnMouseLeave = function (e) {
		clearTimeout(data.link_mouseenter_timeout);
	};

	var buildMainLinksObject = function () {
		var mainLinks = nodes.nav_main.querySelectorAll("[data-main-link]");
		mainLinks.forEach(function (link) {
			main_links[getLinkId(link)] = link;
		});
	};

	// adding event listeners
	bind = function () {
		bodyOnMouseMoveBound = WDN.Debounce(bodyOnMouseMove, 20);
		nodes.links.forEach(function (link) {
			link.addEventListener("mouseenter", linkOnMouseEnter);
			link.addEventListener("mouseleave", linkOnMouseLeave);
		});

		nodes.nav_dropdowns.forEach(function (dropdown) {
			dropdown.addEventListener("mouseleave", navOnMouseLeave);
		});
	};

	init = function () {
		buildMainLinksObject();
		bind();
	};

	init();
})();
